import { toCDNImage } from '~/utils'
import { AiCreateArtworkPattern, TagType } from '~/graphqls/types'

export interface ILabHeader {
  title: string
  enTitle: string
  desc: string
  imgs: string[]
  link: string
  isNew?: boolean
}

const generalHeader = {
  title: '',
  enTitle: '',
  desc: '',
  imgs: [],
  link: '/ai',
}

export const paintHeader = {
  title: '神奇涂抹',
  enTitle: '',
  desc: '神奇涂抹可对受到损坏的图像进行修复重建或者去除图像中的多余物体，恢复图像的原始状态，同时保证图像达到最理想的艺术效果。在去除图片水印和图像补全应用中能够起到很好的效果。',
  imgs: [
    toCDNImage('/images/lab/paint/1.png'),
    toCDNImage('/images/lab/paint/2.png'),
    toCDNImage('/images/lab/paint/3.png'),
    toCDNImage('/images/lab/paint/4.png'),
  ],
  link: '/lab/paint',
}

export const depth2imgHeader = {
  title: '深度图像转换',
  enTitle: '',
  desc: '深度图像转换可推断输入图像的深度，然后使用文本和深度信息生成新图像。可提供与原始图像截然不同的转换，但仍然保持图像的连贯性和深度信息。深度图像转换在保持人物的整体姿势上有很好的效果。',
  imgs: [
    toCDNImage('/images/lab/depth2img/1.png'),
    toCDNImage('/images/lab/depth2img/2.png'),
    toCDNImage('/images/lab/depth2img/3.png'),
    toCDNImage('/images/lab/depth2img/4.png'),
  ],
  link: '/lab/depth2img',
}

export const cannyHeader = {
  title: '边缘检测 Canny',
  enTitle: 'Canny',
  desc: '边缘检测将用户上传的图片作为参考图，提取其中的线稿，再由AI对线稿进行精准绘制。能保留和复原更多的图片细节信息。',
  imgs: [
    toCDNImage('/images/lab/canny/1.jpg'),
    toCDNImage('/images/lab/canny/2.jpg'),
    toCDNImage('/images/lab/canny/3.jpg'),
    toCDNImage('/images/lab/canny/4.jpg'),
  ],
  link: '/lab/canny',
}

export const openposeHeader = {
  title: '姿态识别 Openpose',
  enTitle: 'Openpose',
  desc: '提取人物姿态/姿态识别可根据用户上传的人物图作为AI绘画的参考图，提取人物的姿态和动作，生成一幅相同姿势的图片，效果准确且惊艳。',
  imgs: [
    toCDNImage('/images/lab/openpose/1.jpg'),
    toCDNImage('/images/lab/openpose/2.jpg'),
    toCDNImage('/images/lab/openpose/3.jpg'),
    toCDNImage('/images/lab/openpose/4.jpg'),
  ],
  link: '/lab/openpose',
}

export const mlsdHeader = {
  title: '线段识别 Mlsd',
  enTitle: 'Mlsd',
  desc: '线段识别将识别用户上传的建筑图、物体图和场景图的线条和轮廓，生成预处理图，再生成图片。',
  imgs: [
    toCDNImage('/images/lab/mlsd/1.jpg'),
    toCDNImage('/images/lab/mlsd/2.jpg'),
    toCDNImage('/images/lab/mlsd/3.jpg'),
    toCDNImage('/images/lab/mlsd/4.jpg'),
  ],
  link: '/lab/mlsd',
}

export const hedHeader = {
  title: '边缘提取',
  enTitle: '',
  desc: '对图像边提取线稿，相比边缘检测此模型可以生成更加清晰完整的图',
  imgs: [
    toCDNImage('/images/lab/depth2img/1.png'),
    toCDNImage('/images/lab/depth2img/2.png'),
    toCDNImage('/images/lab/depth2img/3.png'),
    toCDNImage('/images/lab/depth2img/4.png'),
  ],
  link: '/lab/hed',
}

export const depthHeader = {
  title: '深度检测 Depth',
  enTitle: 'Depth',
  desc: '深度检测可根据用户上传的人物图、建筑图或场景图推断输入图像的深度，然后使用文本和深度信息生成新图像，并保留更多结构和层次的细节。',
  imgs: [
    toCDNImage('/images/lab/depth2img/1.png'),
    toCDNImage('/images/lab/depth2img/2.jpg'),
    toCDNImage('/images/lab/depth2img/3.png'),
    toCDNImage('/images/lab/depth2img/4.png'),
  ],
  link: '/lab/depth2img',
}

export const scribbleHeader = {
  title: '涂鸦上色 Scribble',
  enTitle: 'Scribble',
  desc: '涂鸦上色可对用户上传的一张图片或线稿进行着色，生成一张绚丽的涂鸦图。适合对人物进行上色。',
  imgs: [
    toCDNImage('/images/lab/scribble/1.jpg'),
    toCDNImage('/images/lab/scribble/2.jpg'),
    toCDNImage('/images/lab/scribble/3.jpg'),
    toCDNImage('/images/lab/scribble/4.jpg'),
    toCDNImage('/images/lab/scribble/5.jpg'),
    toCDNImage('/images/lab/scribble/6.jpg'),
    toCDNImage('/images/lab/scribble/7.jpg'),
    toCDNImage('/images/lab/scribble/8.jpg'),
    toCDNImage('/images/lab/scribble/9.jpg'),
    toCDNImage('/images/lab/scribble/10.jpg'),
    toCDNImage('/images/lab/scribble/11.jpg'),
    toCDNImage('/images/lab/scribble/12.jpg'),
  ],
  link: '/lab/scribble',
}

export const normalHeader = {
  title: '模型识别 Normal',
  enTitle: 'Normal',
  desc: '模型识别根据用户上传的图片生成一个建模风格的预处理图后再生成图片。适用于人物建模和建筑建模，人物建模效果的更佳。',
  imgs: [
    toCDNImage('/images/lab/normal/1.jpg'),
    toCDNImage('/images/lab/normal/2.jpg'),
    toCDNImage('/images/lab/normal/3.jpg'),
    toCDNImage('/images/lab/normal/4.jpg'),
  ],
  link: '/lab/normal',
}

export const segmentationHeader = {
  title: '语义分割 Seg',
  enTitle: 'Seg',
  desc: '语义分割可配合画面描述对用户上传的图片进行语义分析，识别图片中包含的信息后分割画面内容，并对分割后的区域进行示意。',
  imgs: [
    toCDNImage('/images/lab/segmentation/1.jpg'),
    toCDNImage('/images/lab/segmentation/2.jpg'),
    toCDNImage('/images/lab/segmentation/3.jpg'),
    toCDNImage('/images/lab/segmentation/4.jpg'),
  ],
  link: '/lab/segmentation',
}

export const img2tagHeader = {
  title: '咒语解析器',
  enTitle: '',
  desc: '上传任意图片快速转换成描述词（咒语）',
  imgs: [
    toCDNImage('/images/lab/img2tag/1.png'),
    toCDNImage('/images/lab/img2tag/2.png'),
    toCDNImage('/images/lab/img2tag/3.png'),
    toCDNImage('/images/lab/img2tag/4.png'),
  ],
  link: '/lab/img2tag',
  isNew: true,
}
export const transparentImgHeader = {
  title: '透明图',
  enTitle: '',
  desc: '根据输入的描述词直接生成透明图',
  imgs: [
    toCDNImage('/images/lab/transparent/1.png'),
    toCDNImage('/images/lab/transparent/2.png'),
    toCDNImage('/images/lab/transparent/3.png'),
    toCDNImage('/images/lab/transparent/4.png'),
  ],
  link: '/lab/transparent',
  isNew: true,
}

export const anyTextImgHeader = {
  title: '绘制文字',
  enTitle: '',
  desc: '',
  imgs: [],
  link: '/lab/anytext',
  isNew: false,
}

export const pattern2Header = {
  [AiCreateArtworkPattern.GENERAL]: generalHeader, // placeholder, not lab item
  [AiCreateArtworkPattern.MASK]: paintHeader,
  [AiCreateArtworkPattern.DEPTH]: depthHeader,
  [AiCreateArtworkPattern.CANNY]: cannyHeader,
  [AiCreateArtworkPattern.OPENPOSE]: openposeHeader,
  [AiCreateArtworkPattern.MLSD]: mlsdHeader,
  [AiCreateArtworkPattern.HED]: hedHeader,
  [AiCreateArtworkPattern.SCRIBBLE]: scribbleHeader,
  [AiCreateArtworkPattern.SEG]: segmentationHeader,
  [AiCreateArtworkPattern.NORMAL]: normalHeader,
  [AiCreateArtworkPattern.DEPTH2IMG]: depth2imgHeader,
  [AiCreateArtworkPattern.LAYER_DIFFUSION]: transparentImgHeader,
  // 详情页分享跳转到h5的链接
  [AiCreateArtworkPattern.ANY_TEXT]: anyTextImgHeader,
}

/** 用于lab/index页面排版 */
export const labList: ILabHeader[] = [
  transparentImgHeader,
  openposeHeader,
  depthHeader,
  scribbleHeader,
  cannyHeader,
  normalHeader,
  segmentationHeader,
  mlsdHeader,
  // hedHeader,
  paintHeader,
  // 移到其他独立入口，从列表页移除
  // img2tagHeader,
  {
    title: '画布拓展',
    enTitle: '',
    desc: '画布拓展可以帮助用户扩展创造力，只需使用语言描述即可将图像扩展到其原始边界之外——添加相同风格的视觉元素，或将整幅图片带入新的方向。画布拓展考虑了图像的现有视觉元素，包括阴影、反射和纹理，以保持原始图像的画风不变。',
    imgs: [
      toCDNImage('/images/lab/paint-expanding/1.png'),
      toCDNImage('/images/lab/paint-expanding/2.png'),
      toCDNImage('/images/lab/paint-expanding/3.png'),
      toCDNImage('/images/lab/paint-expanding/4.png'),
    ],
    link: '',
  },
]

/** 属于controlnet的模式，共享一套ui */
export const controlnetPatternArr = [
  AiCreateArtworkPattern.CANNY,
  AiCreateArtworkPattern.OPENPOSE,
  AiCreateArtworkPattern.DEPTH,
  AiCreateArtworkPattern.MLSD,
  AiCreateArtworkPattern.SCRIBBLE,
  AiCreateArtworkPattern.NORMAL,
  AiCreateArtworkPattern.SEG,
  AiCreateArtworkPattern.HED,
]

/** 是否是controlnet模式 */
export const isControlnetPattern = (pattern: AiCreateArtworkPattern) => {
  return controlnetPatternArr.includes(pattern)
}

/** 可以发广场的pattern */
export const canPublishPlazaArr = [
  AiCreateArtworkPattern.GENERAL,
  AiCreateArtworkPattern.DEPTH2IMG,
  ...controlnetPatternArr,
]

/**
 * tag解析之后的类型
 */
export const SpellAnalysisTagType: {
  [key: string]: string
} = {
  [TagType.ANIME]: '漫画',
  [TagType.ART]: '插画',
  [TagType.GENERAL]: '通用',
  [TagType.PHOTO]: '照片',
}
